/**
 * Navigation Configuration
 *
 * Centralized configuration for navigation menus, action buttons, and user dropdown.
 * Modify this file to add/remove/reorder navigation items across all layouts.
 */

export interface NavigationItem {
  label: string;
  route: string;
  icon: string;
  children?: NavigationItem[]; // Optional: for nested menus
}

export interface ActionButton {
  id: string;
  icon: string;
  label: string;
  action?: string; // Optional: predefined action name (e.g., 'theme-toggle')
}

export interface UserMenuItem {
  id: string;
  label: string;
  icon: string;
  action?: string; // Optional: predefined action (e.g., 'theme-toggle', 'logout')
  route?: string;
  url?: string; // Optional: external URL
  dividerAfter?: boolean; // Show divider after this item
}

export function computeActionButtons(): ActionButton[] {
  return [
    {
      id: 'theme-toggle',
      icon: 'dark_mode', // Will be toggled dynamically in component
      label: 'Toggle theme',
      action: 'theme-toggle'
    }
  ];
}

/**
 * User Dropdown Menu Items
 * Desktop shows: Settings, Theme, Feedback, Manual, Logout
 * Mobile includes: Search, Notifications (at top)
 */
export function computeUserMenuItems(environment: any): UserMenuItem[] {
  return [
    {
      id: 'theme-toggle',
      label: 'Switch to Light/Dark Mode', // Will be toggled dynamically
      icon: 'dark_mode', // Will be toggled dynamically
      action: 'theme-toggle',
      dividerAfter: true
    },
    {
      id: 'feedback',
      label: 'Submit Feedback',
      icon: 'feedback',
      url: environment.feedbackForm,
      dividerAfter: false
    },
    {
      id: 'manual',
      label: 'User Manual',
      icon: 'help',
      url: environment.userManual,
      dividerAfter: true
    }
  ];
}

/**
 * Mobile-specific User Menu Items
 * These are shown ONLY in the mobile user dropdown
 */
export function computeMobileUserMenuItems(): UserMenuItem[] {
  return [];
}
